export enum PatientDocumentSourceType {
    RegisterScreen = 1,
    ApprovalFlowUpScreen = 2,
    ReceiveOrderScreen = 3,
    PhysicianOrderScreen = 4,
}
